<div [style.max-width]="maxWidth() || '100%'">
  @if (docId() || doc()) {
    <vl-file-viewer-local
      class="m-auto"
      [deactivateVisu]="deactivateVisu()"
      [showPdf]="showPdf()"
      [showActions]="showActions()"
      [filename]="doc()?.filename"
      [height]="height()"
      [maxHeight]="maxHeight()"
      [maxWidth]="maxWidth()"
      [width]="width()"
      [readOnly]="readOnly()"
      (delete)="onDelete()"
    />
  } @else if (showUploader()) {
    <vl-file-uploader
      class="w100"
      [(uploading)]="uploading"
      [documentType]="'all'"
      (uploadedDoc)="onUploadedDoc($event)"
      [default]="default()"
      [readOnly]="readOnly()"
    />
  }
</div>
